export const Stripe = {
  returnUrl: 'https://stripe-hugo.web.app',
  defaultReturnUrl: 'https://hooks.stripe.com',
};
